import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const worldMentalHealthDayMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.WORLD_MENTAL_HEALTH_DAY,
  iFrameSrcUrl: '/wmhd',
  micrositeUrl: 'wmhd',
  title: {
    id: 'wmhd.title',
    defaultMessage: 'World Mental Health Day',
    description: 'Microsite page title',
  },
  featureFlag: 'isWorldMentalHealthDayToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/using-resilience-to-soar-after-setbacks',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE,
    },
  ],
  page: '202610 wmhd',
  trackUTMParams: {
    utm_campaign: 'Oct1026',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'World Mental Health Day',
  },
  shouldHideForInternational: false,
}
